import styled from 'styled-components';
import {Button} from '@/components/Button';
import {SearchIconComponent} from '@/components/Icons';
import {Typography} from '@/components/Typography';
import {ColumnFlexBox, Flexbox} from '@/styled-components';
import {LAYOUT_Z_INDEX, palette} from '@/styles';

interface IProps {
  text?: string;
  isError?: boolean;
  onFocus?(): void;
  onClick?(): void;
}

export const SearchCard = ({text, isError, onFocus, onClick}: IProps) => {
  return (
    <Root>
      <ColumnFlexBox gap={16}>
        <Typography variant="medium16" fontWeight={600}>
          어디를 분석하고 싶으세요?
        </Typography>
        <LocationInput onClick={onFocus}>
          <SearchIconComponent width={24} height={24} color={palette.gray500} />
          <Typography variant="medium16" ellipsis>
            {text ||
              (isError ? '분석할 수 없는 지역입니다.' : '위치 탐색 중...')}
          </Typography>
        </LocationInput>
        <Button
          variant="fill"
          color="primary"
          size="medium"
          disabled={!text}
          onClick={onClick}
        >
          이 지역 알아보기
        </Button>
      </ColumnFlexBox>
    </Root>
  );
};

const Root = styled('div')`
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 12px;
  z-index: ${LAYOUT_Z_INDEX.NAVBAR};
  background-color: ${palette.white};
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
`;

const LocationInput = styled(Flexbox)`
  border-radius: 8px;
  border: 1px solid ${palette.gray150};
  display: flex;
  width: 100%;
  padding: 10px 16px;
  gap: 10px;
  color: ${palette.gray500};
  cursor: pointer;
  & > svg {
    flex-shrink: 0;
  }
`;
